import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiResponse, ReportsData } from '../../data/system/reports';
import { env } from '../../../app.constant';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ReportsService extends ReportsData {

  constructor(private http: HttpClient) { super(); }

  getSabaudb(params: any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.reports_sabaudb}`;
    return this.http.post<ApiResponse>(host, params);
  }

  getSabaudbAccountSummary(params: any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.reports_sabaudb_account_summary}`;
    return this.http.post<ApiResponse>(host, params);
  }

  getFar2(params: any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.reports_far2}`;
    return this.http.post<ApiResponse>(host, params);
  }

  getFar2A(params: any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.reports_far2a}`;
    return this.http.post<ApiResponse>(host, params);
  }

  getSabaudbData(params: any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.reports_sabaudb_data}`;
    return this.http.post<ApiResponse>(host, params);
  }

  getRegistry(params: any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.reports_registry}`;
    return this.http.post<ApiResponse>(host, params);
  }

  getRegistrySummary(params: any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.reports_registry_summary}`;
    return this.http.post<ApiResponse>(host, params);
  }

  getConsolidationSabaudbPRE(params: any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.reports_consolidation_sabaudb_pre}`;
    return this.http.post<ApiResponse>(host, params);
  }

}
